import { render } from "./TopicsManager.vue?vue&type=template&id=7a76a13f&scoped=true"
import script from "./TopicsManager.vue?vue&type=script&lang=js"
export * from "./TopicsManager.vue?vue&type=script&lang=js"

import "./TopicsManager.vue?vue&type=style&index=0&id=7a76a13f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a76a13f"]])

export default __exports__